import { default as edit2bhhJcx8jlMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_plans/[account_plan_id]/edit.vue?macro=true";
import { default as indexzTyQ57WqrtMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_plans/[account_plan_id]/index.vue?macro=true";
import { default as _91account_plan_id_930cnvZUGwEhMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_plans/[account_plan_id].vue?macro=true";
import { default as editEAIHsHCNpzMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/[account_requested_plan_id]/edit.vue?macro=true";
import { default as indexzBgEV6ze7QMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/[account_requested_plan_id]/index.vue?macro=true";
import { default as _91account_requested_plan_id_93ug00dZsp6QMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/[account_requested_plan_id].vue?macro=true";
import { default as index2jFF1uoYJUMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/index.vue?macro=true";
import { default as newSDJbih4iDwMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/new.vue?macro=true";
import { default as account_requested_plansfHtwrDzLGuMeta } from "/codebuild/output/src1332377934/src/pages/admin/account_requested_plans.vue?macro=true";
import { default as editYpOaGXgrhxMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/[account_requested_plan_id]/edit.vue?macro=true";
import { default as indexkQNGXGCpxDMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/[account_requested_plan_id]/index.vue?macro=true";
import { default as _91account_requested_plan_id_93hHwEkE0dsHMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/[account_requested_plan_id].vue?macro=true";
import { default as index3fEn4M1dhaMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/index.vue?macro=true";
import { default as newBioxyXCJecMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/new.vue?macro=true";
import { default as account_requested_plansbozLVG3YmVMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans.vue?macro=true";
import { default as editFbEaD4MFA5Meta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/[caller_id_id]/edit.vue?macro=true";
import { default as indexsYKedOyd2RMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/[caller_id_id]/index.vue?macro=true";
import { default as _91caller_id_id_930aELtR6bBMMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/[caller_id_id].vue?macro=true";
import { default as indexLTZddm8eBcMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/index.vue?macro=true";
import { default as newIE5z9kg18wMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/new.vue?macro=true";
import { default as caller_ids3Hb1OpEODrMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids.vue?macro=true";
import { default as editsygb2t41zQMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/edit.vue?macro=true";
import { default as indexSQqTNgfM5FMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/index.vue?macro=true";
import { default as edit51FQlOgDkhMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/[sms_masking_id]/edit.vue?macro=true";
import { default as indexE2ViGEZMA7Meta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/[sms_masking_id]/index.vue?macro=true";
import { default as _91sms_masking_id_93DXZ2ZA0HwkMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/[sms_masking_id].vue?macro=true";
import { default as indexKibuk3iCvtMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/index.vue?macro=true";
import { default as neww07WUobgh8Meta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/new.vue?macro=true";
import { default as sms_maskings3xdYg0EOZHMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings.vue?macro=true";
import { default as _91account_id_93i8tXMyYTfYMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id].vue?macro=true";
import { default as indexUfFNJw6KhIMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/index.vue?macro=true";
import { default as wizard_plan_selectionZUjlTqdQYEMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/wizard_plan_selection.vue?macro=true";
import { default as wizard8zYy4JSVN4Meta } from "/codebuild/output/src1332377934/src/pages/admin/accounts/wizard.vue?macro=true";
import { default as accountsbj6W2io1OAMeta } from "/codebuild/output/src1332377934/src/pages/admin/accounts.vue?macro=true";
import { default as edit1khn9zmRo6Meta } from "/codebuild/output/src1332377934/src/pages/admin/admin_users/[admin_user_id]/edit.vue?macro=true";
import { default as indexH6g3K4hcIEMeta } from "/codebuild/output/src1332377934/src/pages/admin/admin_users/[admin_user_id]/index.vue?macro=true";
import { default as _91admin_user_id_93LCRumvgb1tMeta } from "/codebuild/output/src1332377934/src/pages/admin/admin_users/[admin_user_id].vue?macro=true";
import { default as indext1VzYrOUiKMeta } from "/codebuild/output/src1332377934/src/pages/admin/admin_users/index.vue?macro=true";
import { default as newhpfUi7s98iMeta } from "/codebuild/output/src1332377934/src/pages/admin/admin_users/new.vue?macro=true";
import { default as admin_usersh3FRmVwSPZMeta } from "/codebuild/output/src1332377934/src/pages/admin/admin_users.vue?macro=true";
import { default as indexS0H3UZKVh6Meta } from "/codebuild/output/src1332377934/src/pages/admin/audit_trails/index.vue?macro=true";
import { default as audit_trails7zIKOl3cvBMeta } from "/codebuild/output/src1332377934/src/pages/admin/audit_trails.vue?macro=true";
import { default as editBlTe3QYEoHMeta } from "/codebuild/output/src1332377934/src/pages/admin/billings/[billing_id]/edit.vue?macro=true";
import { default as indexmr1kouHjdRMeta } from "/codebuild/output/src1332377934/src/pages/admin/billings/[billing_id]/index.vue?macro=true";
import { default as _91billing_id_933bOYP3pdUoMeta } from "/codebuild/output/src1332377934/src/pages/admin/billings/[billing_id].vue?macro=true";
import { default as indexPFpfRUlkN6Meta } from "/codebuild/output/src1332377934/src/pages/admin/billings/index.vue?macro=true";
import { default as new1lyEIMF6ZgMeta } from "/codebuild/output/src1332377934/src/pages/admin/billings/new.vue?macro=true";
import { default as billingsZIEvDSzlxwMeta } from "/codebuild/output/src1332377934/src/pages/admin/billings.vue?macro=true";
import { default as edit5MsEMHfvbjMeta } from "/codebuild/output/src1332377934/src/pages/admin/caller_ids/[caller_id_id]/edit.vue?macro=true";
import { default as indexpAJ0jJKR8YMeta } from "/codebuild/output/src1332377934/src/pages/admin/caller_ids/[caller_id_id]/index.vue?macro=true";
import { default as _91caller_id_id_93YHMdvKIT91Meta } from "/codebuild/output/src1332377934/src/pages/admin/caller_ids/[caller_id_id].vue?macro=true";
import { default as indexAMudmIpW0OMeta } from "/codebuild/output/src1332377934/src/pages/admin/caller_ids/index.vue?macro=true";
import { default as newUXo5oDZE1CMeta } from "/codebuild/output/src1332377934/src/pages/admin/caller_ids/new.vue?macro=true";
import { default as caller_idsKepo0yoReQMeta } from "/codebuild/output/src1332377934/src/pages/admin/caller_ids.vue?macro=true";
import { default as editxfW8G4J5p1Meta } from "/codebuild/output/src1332377934/src/pages/admin/campaign_settings/[campaign_setting_id]/edit.vue?macro=true";
import { default as indexrCQAxNqNVrMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaign_settings/[campaign_setting_id]/index.vue?macro=true";
import { default as _91campaign_setting_id_93CUtjSh1bGBMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaign_settings/[campaign_setting_id].vue?macro=true";
import { default as editgWyzyxtihMMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/edit.vue?macro=true";
import { default as index7VVY36UTlMMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/index.vue?macro=true";
import { default as editz2ZTxVFu6oMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/[outbound_call_transaction_id]/edit.vue?macro=true";
import { default as indexHBd2MpxbfvMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/[outbound_call_transaction_id]/index.vue?macro=true";
import { default as _91outbound_call_transaction_id_93X3D0S7Yr4zMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/[outbound_call_transaction_id].vue?macro=true";
import { default as indexTf7v6IkEhtMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/index.vue?macro=true";
import { default as newYdBnam8fz3Meta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/new.vue?macro=true";
import { default as outbound_call_transactionsSyihUWet2XMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions.vue?macro=true";
import { default as _91campaign_id_93vEXGD91MjnMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id].vue?macro=true";
import { default as indexT5Jk5sh9ofMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/index.vue?macro=true";
import { default as newNeYdB3zRjuMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns/new.vue?macro=true";
import { default as campaignsJirBcyOB9gMeta } from "/codebuild/output/src1332377934/src/pages/admin/campaigns.vue?macro=true";
import { default as indexn9eZFKEX7AMeta } from "/codebuild/output/src1332377934/src/pages/admin/custom_emails/[custom_email_id]/index.vue?macro=true";
import { default as _91custom_email_id_933aGf6HmpmqMeta } from "/codebuild/output/src1332377934/src/pages/admin/custom_emails/[custom_email_id].vue?macro=true";
import { default as indexluW1I0qVWjMeta } from "/codebuild/output/src1332377934/src/pages/admin/custom_emails/index.vue?macro=true";
import { default as newJu4cZXzymoMeta } from "/codebuild/output/src1332377934/src/pages/admin/custom_emails/new.vue?macro=true";
import { default as custom_emailsVdOfn07PEOMeta } from "/codebuild/output/src1332377934/src/pages/admin/custom_emails.vue?macro=true";
import { default as indexCcXG9xY9KDMeta } from "/codebuild/output/src1332377934/src/pages/admin/dashboard/index.vue?macro=true";
import { default as dashboardnNq96eiiG4Meta } from "/codebuild/output/src1332377934/src/pages/admin/dashboard.vue?macro=true";
import { default as index0OPBczMLtAMeta } from "/codebuild/output/src1332377934/src/pages/admin/inquiries/[inquiry_id]/index.vue?macro=true";
import { default as _91inquiry_id_93TiOqU4yWW2Meta } from "/codebuild/output/src1332377934/src/pages/admin/inquiries/[inquiry_id].vue?macro=true";
import { default as indexP7oReG5H3pMeta } from "/codebuild/output/src1332377934/src/pages/admin/inquiries/index.vue?macro=true";
import { default as newH7K0c6kkISMeta } from "/codebuild/output/src1332377934/src/pages/admin/inquiries/new.vue?macro=true";
import { default as inquiriesHYEHr2t4HKMeta } from "/codebuild/output/src1332377934/src/pages/admin/inquiries.vue?macro=true";
import { default as indexwb5Jyab79MMeta } from "/codebuild/output/src1332377934/src/pages/admin/login/index.vue?macro=true";
import { default as loginGsJanrWgUKMeta } from "/codebuild/output/src1332377934/src/pages/admin/login.vue?macro=true";
import { default as index6OLGGLnj9rMeta } from "/codebuild/output/src1332377934/src/pages/admin/password/edit/index.vue?macro=true";
import { default as index21hrkRnbR6Meta } from "/codebuild/output/src1332377934/src/pages/admin/password/new/index.vue?macro=true";
import { default as indexfiI5YVGc2iMeta } from "/codebuild/output/src1332377934/src/pages/admin/reports/index.vue?macro=true";
import { default as reportsuquZV5r9IlMeta } from "/codebuild/output/src1332377934/src/pages/admin/reports.vue?macro=true";
import { default as edituooYjkbTEMMeta } from "/codebuild/output/src1332377934/src/pages/admin/sms_maskings/[sms_masking_id]/edit.vue?macro=true";
import { default as indexTbkTF6C4WBMeta } from "/codebuild/output/src1332377934/src/pages/admin/sms_maskings/[sms_masking_id]/index.vue?macro=true";
import { default as _91sms_masking_id_937Yq715HqMXMeta } from "/codebuild/output/src1332377934/src/pages/admin/sms_maskings/[sms_masking_id].vue?macro=true";
import { default as indexn3qKoi5ahoMeta } from "/codebuild/output/src1332377934/src/pages/admin/sms_maskings/index.vue?macro=true";
import { default as newEPx24wLIzcMeta } from "/codebuild/output/src1332377934/src/pages/admin/sms_maskings/new.vue?macro=true";
import { default as sms_maskingsmSDMtqMwLvMeta } from "/codebuild/output/src1332377934/src/pages/admin/sms_maskings.vue?macro=true";
import { default as editmgm7RBLg0pMeta } from "/codebuild/output/src1332377934/src/pages/admin/users/[user_id]/edit.vue?macro=true";
import { default as indexqODNmed2QrMeta } from "/codebuild/output/src1332377934/src/pages/admin/users/[user_id]/index.vue?macro=true";
import { default as _91user_id_93OV13ot21yTMeta } from "/codebuild/output/src1332377934/src/pages/admin/users/[user_id].vue?macro=true";
import { default as indexjqyLBfmpj5Meta } from "/codebuild/output/src1332377934/src/pages/admin/users/index.vue?macro=true";
import { default as newQGMESc0rO8Meta } from "/codebuild/output/src1332377934/src/pages/admin/users/new.vue?macro=true";
import { default as usersc9uL0sFKgMMeta } from "/codebuild/output/src1332377934/src/pages/admin/users.vue?macro=true";
import { default as editCJbvCGj0fEMeta } from "/codebuild/output/src1332377934/src/pages/admin/wallets/[wallet_id]/edit.vue?macro=true";
import { default as indexcc7ASpMDfOMeta } from "/codebuild/output/src1332377934/src/pages/admin/wallets/[wallet_id]/index.vue?macro=true";
import { default as _91wallet_id_93LV7eimG0xEMeta } from "/codebuild/output/src1332377934/src/pages/admin/wallets/[wallet_id].vue?macro=true";
import { default as adminXF7wRbHDD1Meta } from "/codebuild/output/src1332377934/src/pages/admin.vue?macro=true";
import { default as indexM7vvfplj2QMeta } from "/codebuild/output/src1332377934/src/pages/audit_logs/index.vue?macro=true";
import { default as indexQdGITE8dEmMeta } from "/codebuild/output/src1332377934/src/pages/billings/index.vue?macro=true";
import { default as indexwt0h2JMpSEMeta } from "/codebuild/output/src1332377934/src/pages/call_out/reports/index.vue?macro=true";
import { default as _91id_93YTOoynxhIOMeta } from "/codebuild/output/src1332377934/src/pages/call_recordings/[id].vue?macro=true";
import { default as index8emJTl2pzjMeta } from "/codebuild/output/src1332377934/src/pages/campaigns/[id]/index.vue?macro=true";
import { default as indexWP5PnavcUTMeta } from "/codebuild/output/src1332377934/src/pages/campaigns/index.vue?macro=true";
import { default as index1WtvJktryRMeta } from "/codebuild/output/src1332377934/src/pages/dashboard/index.vue?macro=true";
import { default as validate_email_changeslRNPN3NfFNMeta } from "/codebuild/output/src1332377934/src/pages/data_verifications/[id]/validate_email_changes.vue?macro=true";
import { default as indexMyCnNmDEmOMeta } from "/codebuild/output/src1332377934/src/pages/help/index.vue?macro=true";
import { default as indexZw2qRISpDJMeta } from "/codebuild/output/src1332377934/src/pages/index.vue?macro=true";
import { default as indextEc0viaT5tMeta } from "/codebuild/output/src1332377934/src/pages/inquiry/index.vue?macro=true";
import { default as editorvOK56c47KtMeta } from "/codebuild/output/src1332377934/src/pages/ivr_trees/[id]/editor.vue?macro=true";
import { default as index4ub0A5D8HPMeta } from "/codebuild/output/src1332377934/src/pages/ivr_trees/index.vue?macro=true";
import { default as verify_emaill37p8wpj6TMeta } from "/codebuild/output/src1332377934/src/pages/profiles/[user_id]/verify_email.vue?macro=true";
import { default as welcome_dashboard0wIZb4eGlvMeta } from "/codebuild/output/src1332377934/src/pages/profiles/[user_id]/welcome_dashboard.vue?macro=true";
import { default as indexbzPkVNONxOMeta } from "/codebuild/output/src1332377934/src/pages/profiles/index.vue?macro=true";
import { default as indexnCEmVxvBUmMeta } from "/codebuild/output/src1332377934/src/pages/sub_users/users/index.vue?macro=true";
import { default as indexNMovEzJ5SyMeta } from "/codebuild/output/src1332377934/src/pages/terms_and_conditions/index.vue?macro=true";
import { default as indexF3tP7fqxekMeta } from "/codebuild/output/src1332377934/src/pages/users/password/edit/index.vue?macro=true";
import { default as indexQzdulnbVcTMeta } from "/codebuild/output/src1332377934/src/pages/users/password/new/index.vue?macro=true";
import { default as index6EDCMFM6ZWMeta } from "/codebuild/output/src1332377934/src/pages/users/sign_in/index.vue?macro=true";
export default [
  {
    name: adminXF7wRbHDD1Meta?.name ?? "admin",
    path: adminXF7wRbHDD1Meta?.path ?? "/admin",
    children: [
  {
    path: _91account_plan_id_930cnvZUGwEhMeta?.path ?? "account_plans/:account_plan_id()",
    children: [
  {
    name: edit2bhhJcx8jlMeta?.name ?? "admin-account_plans-account_plan_id-edit",
    path: edit2bhhJcx8jlMeta?.path ?? "edit",
    meta: edit2bhhJcx8jlMeta || {},
    alias: edit2bhhJcx8jlMeta?.alias || [],
    redirect: edit2bhhJcx8jlMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_plans/[account_plan_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexzTyQ57WqrtMeta?.name ?? "admin-account_plans-account_plan_id",
    path: indexzTyQ57WqrtMeta?.path ?? "",
    meta: indexzTyQ57WqrtMeta || {},
    alias: indexzTyQ57WqrtMeta?.alias || [],
    redirect: indexzTyQ57WqrtMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_plans/[account_plan_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91account_plan_id_930cnvZUGwEhMeta?.name ?? undefined,
    meta: _91account_plan_id_930cnvZUGwEhMeta || {},
    alias: _91account_plan_id_930cnvZUGwEhMeta?.alias || [],
    redirect: _91account_plan_id_930cnvZUGwEhMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_plans/[account_plan_id].vue").then(m => m.default || m)
  },
  {
    path: account_requested_plansfHtwrDzLGuMeta?.path ?? "account_requested_plans",
    children: [
  {
    path: _91account_requested_plan_id_93ug00dZsp6QMeta?.path ?? ":account_requested_plan_id()",
    children: [
  {
    name: editEAIHsHCNpzMeta?.name ?? "admin-account_requested_plans-account_requested_plan_id-edit",
    path: editEAIHsHCNpzMeta?.path ?? "edit",
    meta: editEAIHsHCNpzMeta || {},
    alias: editEAIHsHCNpzMeta?.alias || [],
    redirect: editEAIHsHCNpzMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/[account_requested_plan_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexzBgEV6ze7QMeta?.name ?? "admin-account_requested_plans-account_requested_plan_id",
    path: indexzBgEV6ze7QMeta?.path ?? "",
    meta: indexzBgEV6ze7QMeta || {},
    alias: indexzBgEV6ze7QMeta?.alias || [],
    redirect: indexzBgEV6ze7QMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/[account_requested_plan_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91account_requested_plan_id_93ug00dZsp6QMeta?.name ?? undefined,
    meta: _91account_requested_plan_id_93ug00dZsp6QMeta || {},
    alias: _91account_requested_plan_id_93ug00dZsp6QMeta?.alias || [],
    redirect: _91account_requested_plan_id_93ug00dZsp6QMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/[account_requested_plan_id].vue").then(m => m.default || m)
  },
  {
    name: index2jFF1uoYJUMeta?.name ?? "admin-account_requested_plans",
    path: index2jFF1uoYJUMeta?.path ?? "",
    meta: index2jFF1uoYJUMeta || {},
    alias: index2jFF1uoYJUMeta?.alias || [],
    redirect: index2jFF1uoYJUMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/index.vue").then(m => m.default || m)
  },
  {
    name: newSDJbih4iDwMeta?.name ?? "admin-account_requested_plans-new",
    path: newSDJbih4iDwMeta?.path ?? "new",
    meta: newSDJbih4iDwMeta || {},
    alias: newSDJbih4iDwMeta?.alias || [],
    redirect: newSDJbih4iDwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_requested_plans/new.vue").then(m => m.default || m)
  }
],
    name: account_requested_plansfHtwrDzLGuMeta?.name ?? undefined,
    meta: account_requested_plansfHtwrDzLGuMeta || {},
    alias: account_requested_plansfHtwrDzLGuMeta?.alias || [],
    redirect: account_requested_plansfHtwrDzLGuMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/account_requested_plans.vue").then(m => m.default || m)
  },
  {
    path: accountsbj6W2io1OAMeta?.path ?? "accounts",
    children: [
  {
    path: _91account_id_93i8tXMyYTfYMeta?.path ?? ":account_id()",
    children: [
  {
    path: account_requested_plansbozLVG3YmVMeta?.path ?? "account_requested_plans",
    children: [
  {
    path: _91account_requested_plan_id_93hHwEkE0dsHMeta?.path ?? ":account_requested_plan_id()",
    children: [
  {
    name: editYpOaGXgrhxMeta?.name ?? "admin-accounts-account_id-account_requested_plans-account_requested_plan_id-edit",
    path: editYpOaGXgrhxMeta?.path ?? "edit",
    meta: editYpOaGXgrhxMeta || {},
    alias: editYpOaGXgrhxMeta?.alias || [],
    redirect: editYpOaGXgrhxMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/[account_requested_plan_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexkQNGXGCpxDMeta?.name ?? "admin-accounts-account_id-account_requested_plans-account_requested_plan_id",
    path: indexkQNGXGCpxDMeta?.path ?? "",
    meta: indexkQNGXGCpxDMeta || {},
    alias: indexkQNGXGCpxDMeta?.alias || [],
    redirect: indexkQNGXGCpxDMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/[account_requested_plan_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91account_requested_plan_id_93hHwEkE0dsHMeta?.name ?? undefined,
    meta: _91account_requested_plan_id_93hHwEkE0dsHMeta || {},
    alias: _91account_requested_plan_id_93hHwEkE0dsHMeta?.alias || [],
    redirect: _91account_requested_plan_id_93hHwEkE0dsHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/[account_requested_plan_id].vue").then(m => m.default || m)
  },
  {
    name: index3fEn4M1dhaMeta?.name ?? "admin-accounts-account_id-account_requested_plans",
    path: index3fEn4M1dhaMeta?.path ?? "",
    meta: index3fEn4M1dhaMeta || {},
    alias: index3fEn4M1dhaMeta?.alias || [],
    redirect: index3fEn4M1dhaMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/index.vue").then(m => m.default || m)
  },
  {
    name: newBioxyXCJecMeta?.name ?? "admin-accounts-account_id-account_requested_plans-new",
    path: newBioxyXCJecMeta?.path ?? "new",
    meta: newBioxyXCJecMeta || {},
    alias: newBioxyXCJecMeta?.alias || [],
    redirect: newBioxyXCJecMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans/new.vue").then(m => m.default || m)
  }
],
    name: account_requested_plansbozLVG3YmVMeta?.name ?? undefined,
    meta: account_requested_plansbozLVG3YmVMeta || {},
    alias: account_requested_plansbozLVG3YmVMeta?.alias || [],
    redirect: account_requested_plansbozLVG3YmVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/account_requested_plans.vue").then(m => m.default || m)
  },
  {
    path: caller_ids3Hb1OpEODrMeta?.path ?? "caller_ids",
    children: [
  {
    path: _91caller_id_id_930aELtR6bBMMeta?.path ?? ":caller_id_id()",
    children: [
  {
    name: editFbEaD4MFA5Meta?.name ?? "admin-accounts-account_id-caller_ids-caller_id_id-edit",
    path: editFbEaD4MFA5Meta?.path ?? "edit",
    meta: editFbEaD4MFA5Meta || {},
    alias: editFbEaD4MFA5Meta?.alias || [],
    redirect: editFbEaD4MFA5Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/[caller_id_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexsYKedOyd2RMeta?.name ?? "admin-accounts-account_id-caller_ids-caller_id_id",
    path: indexsYKedOyd2RMeta?.path ?? "",
    meta: indexsYKedOyd2RMeta || {},
    alias: indexsYKedOyd2RMeta?.alias || [],
    redirect: indexsYKedOyd2RMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/[caller_id_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91caller_id_id_930aELtR6bBMMeta?.name ?? undefined,
    meta: _91caller_id_id_930aELtR6bBMMeta || {},
    alias: _91caller_id_id_930aELtR6bBMMeta?.alias || [],
    redirect: _91caller_id_id_930aELtR6bBMMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/[caller_id_id].vue").then(m => m.default || m)
  },
  {
    name: indexLTZddm8eBcMeta?.name ?? "admin-accounts-account_id-caller_ids",
    path: indexLTZddm8eBcMeta?.path ?? "",
    meta: indexLTZddm8eBcMeta || {},
    alias: indexLTZddm8eBcMeta?.alias || [],
    redirect: indexLTZddm8eBcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/index.vue").then(m => m.default || m)
  },
  {
    name: newIE5z9kg18wMeta?.name ?? "admin-accounts-account_id-caller_ids-new",
    path: newIE5z9kg18wMeta?.path ?? "new",
    meta: newIE5z9kg18wMeta || {},
    alias: newIE5z9kg18wMeta?.alias || [],
    redirect: newIE5z9kg18wMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids/new.vue").then(m => m.default || m)
  }
],
    name: caller_ids3Hb1OpEODrMeta?.name ?? undefined,
    meta: caller_ids3Hb1OpEODrMeta || {},
    alias: caller_ids3Hb1OpEODrMeta?.alias || [],
    redirect: caller_ids3Hb1OpEODrMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/caller_ids.vue").then(m => m.default || m)
  },
  {
    name: editsygb2t41zQMeta?.name ?? "admin-accounts-account_id-edit",
    path: editsygb2t41zQMeta?.path ?? "edit",
    meta: editsygb2t41zQMeta || {},
    alias: editsygb2t41zQMeta?.alias || [],
    redirect: editsygb2t41zQMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexSQqTNgfM5FMeta?.name ?? "admin-accounts-account_id",
    path: indexSQqTNgfM5FMeta?.path ?? "",
    meta: indexSQqTNgfM5FMeta || {},
    alias: indexSQqTNgfM5FMeta?.alias || [],
    redirect: indexSQqTNgfM5FMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/index.vue").then(m => m.default || m)
  },
  {
    path: sms_maskings3xdYg0EOZHMeta?.path ?? "sms_maskings",
    children: [
  {
    path: _91sms_masking_id_93DXZ2ZA0HwkMeta?.path ?? ":sms_masking_id()",
    children: [
  {
    name: edit51FQlOgDkhMeta?.name ?? "admin-accounts-account_id-sms_maskings-sms_masking_id-edit",
    path: edit51FQlOgDkhMeta?.path ?? "edit",
    meta: edit51FQlOgDkhMeta || {},
    alias: edit51FQlOgDkhMeta?.alias || [],
    redirect: edit51FQlOgDkhMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/[sms_masking_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexE2ViGEZMA7Meta?.name ?? "admin-accounts-account_id-sms_maskings-sms_masking_id",
    path: indexE2ViGEZMA7Meta?.path ?? "",
    meta: indexE2ViGEZMA7Meta || {},
    alias: indexE2ViGEZMA7Meta?.alias || [],
    redirect: indexE2ViGEZMA7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/[sms_masking_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91sms_masking_id_93DXZ2ZA0HwkMeta?.name ?? undefined,
    meta: _91sms_masking_id_93DXZ2ZA0HwkMeta || {},
    alias: _91sms_masking_id_93DXZ2ZA0HwkMeta?.alias || [],
    redirect: _91sms_masking_id_93DXZ2ZA0HwkMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/[sms_masking_id].vue").then(m => m.default || m)
  },
  {
    name: indexKibuk3iCvtMeta?.name ?? "admin-accounts-account_id-sms_maskings",
    path: indexKibuk3iCvtMeta?.path ?? "",
    meta: indexKibuk3iCvtMeta || {},
    alias: indexKibuk3iCvtMeta?.alias || [],
    redirect: indexKibuk3iCvtMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/index.vue").then(m => m.default || m)
  },
  {
    name: neww07WUobgh8Meta?.name ?? "admin-accounts-account_id-sms_maskings-new",
    path: neww07WUobgh8Meta?.path ?? "new",
    meta: neww07WUobgh8Meta || {},
    alias: neww07WUobgh8Meta?.alias || [],
    redirect: neww07WUobgh8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings/new.vue").then(m => m.default || m)
  }
],
    name: sms_maskings3xdYg0EOZHMeta?.name ?? undefined,
    meta: sms_maskings3xdYg0EOZHMeta || {},
    alias: sms_maskings3xdYg0EOZHMeta?.alias || [],
    redirect: sms_maskings3xdYg0EOZHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id]/sms_maskings.vue").then(m => m.default || m)
  }
],
    name: _91account_id_93i8tXMyYTfYMeta?.name ?? undefined,
    meta: _91account_id_93i8tXMyYTfYMeta || {},
    alias: _91account_id_93i8tXMyYTfYMeta?.alias || [],
    redirect: _91account_id_93i8tXMyYTfYMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/[account_id].vue").then(m => m.default || m)
  },
  {
    name: indexUfFNJw6KhIMeta?.name ?? "admin-accounts",
    path: indexUfFNJw6KhIMeta?.path ?? "",
    meta: indexUfFNJw6KhIMeta || {},
    alias: indexUfFNJw6KhIMeta?.alias || [],
    redirect: indexUfFNJw6KhIMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/index.vue").then(m => m.default || m)
  },
  {
    name: wizard_plan_selectionZUjlTqdQYEMeta?.name ?? "admin-accounts-wizard_plan_selection",
    path: wizard_plan_selectionZUjlTqdQYEMeta?.path ?? "wizard_plan_selection",
    meta: wizard_plan_selectionZUjlTqdQYEMeta || {},
    alias: wizard_plan_selectionZUjlTqdQYEMeta?.alias || [],
    redirect: wizard_plan_selectionZUjlTqdQYEMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/wizard_plan_selection.vue").then(m => m.default || m)
  },
  {
    name: wizard8zYy4JSVN4Meta?.name ?? "admin-accounts-wizard",
    path: wizard8zYy4JSVN4Meta?.path ?? "wizard",
    meta: wizard8zYy4JSVN4Meta || {},
    alias: wizard8zYy4JSVN4Meta?.alias || [],
    redirect: wizard8zYy4JSVN4Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts/wizard.vue").then(m => m.default || m)
  }
],
    name: accountsbj6W2io1OAMeta?.name ?? undefined,
    meta: accountsbj6W2io1OAMeta || {},
    alias: accountsbj6W2io1OAMeta?.alias || [],
    redirect: accountsbj6W2io1OAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/accounts.vue").then(m => m.default || m)
  },
  {
    path: admin_usersh3FRmVwSPZMeta?.path ?? "admin_users",
    children: [
  {
    path: _91admin_user_id_93LCRumvgb1tMeta?.path ?? ":admin_user_id()",
    children: [
  {
    name: edit1khn9zmRo6Meta?.name ?? "admin-admin_users-admin_user_id-edit",
    path: edit1khn9zmRo6Meta?.path ?? "edit",
    meta: edit1khn9zmRo6Meta || {},
    alias: edit1khn9zmRo6Meta?.alias || [],
    redirect: edit1khn9zmRo6Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/admin_users/[admin_user_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexH6g3K4hcIEMeta?.name ?? "admin-admin_users-admin_user_id",
    path: indexH6g3K4hcIEMeta?.path ?? "",
    meta: indexH6g3K4hcIEMeta || {},
    alias: indexH6g3K4hcIEMeta?.alias || [],
    redirect: indexH6g3K4hcIEMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/admin_users/[admin_user_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91admin_user_id_93LCRumvgb1tMeta?.name ?? undefined,
    meta: _91admin_user_id_93LCRumvgb1tMeta || {},
    alias: _91admin_user_id_93LCRumvgb1tMeta?.alias || [],
    redirect: _91admin_user_id_93LCRumvgb1tMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/admin_users/[admin_user_id].vue").then(m => m.default || m)
  },
  {
    name: indext1VzYrOUiKMeta?.name ?? "admin-admin_users",
    path: indext1VzYrOUiKMeta?.path ?? "",
    meta: indext1VzYrOUiKMeta || {},
    alias: indext1VzYrOUiKMeta?.alias || [],
    redirect: indext1VzYrOUiKMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/admin_users/index.vue").then(m => m.default || m)
  },
  {
    name: newhpfUi7s98iMeta?.name ?? "admin-admin_users-new",
    path: newhpfUi7s98iMeta?.path ?? "new",
    meta: newhpfUi7s98iMeta || {},
    alias: newhpfUi7s98iMeta?.alias || [],
    redirect: newhpfUi7s98iMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/admin_users/new.vue").then(m => m.default || m)
  }
],
    name: admin_usersh3FRmVwSPZMeta?.name ?? undefined,
    meta: admin_usersh3FRmVwSPZMeta || {},
    alias: admin_usersh3FRmVwSPZMeta?.alias || [],
    redirect: admin_usersh3FRmVwSPZMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/admin_users.vue").then(m => m.default || m)
  },
  {
    path: audit_trails7zIKOl3cvBMeta?.path ?? "audit_trails",
    children: [
  {
    name: indexS0H3UZKVh6Meta?.name ?? "admin-audit_trails",
    path: indexS0H3UZKVh6Meta?.path ?? "",
    meta: indexS0H3UZKVh6Meta || {},
    alias: indexS0H3UZKVh6Meta?.alias || [],
    redirect: indexS0H3UZKVh6Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/audit_trails/index.vue").then(m => m.default || m)
  }
],
    name: audit_trails7zIKOl3cvBMeta?.name ?? undefined,
    meta: audit_trails7zIKOl3cvBMeta || {},
    alias: audit_trails7zIKOl3cvBMeta?.alias || [],
    redirect: audit_trails7zIKOl3cvBMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/audit_trails.vue").then(m => m.default || m)
  },
  {
    path: billingsZIEvDSzlxwMeta?.path ?? "billings",
    children: [
  {
    path: _91billing_id_933bOYP3pdUoMeta?.path ?? ":billing_id()",
    children: [
  {
    name: editBlTe3QYEoHMeta?.name ?? "admin-billings-billing_id-edit",
    path: editBlTe3QYEoHMeta?.path ?? "edit",
    meta: editBlTe3QYEoHMeta || {},
    alias: editBlTe3QYEoHMeta?.alias || [],
    redirect: editBlTe3QYEoHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/billings/[billing_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexmr1kouHjdRMeta?.name ?? "admin-billings-billing_id",
    path: indexmr1kouHjdRMeta?.path ?? "",
    meta: indexmr1kouHjdRMeta || {},
    alias: indexmr1kouHjdRMeta?.alias || [],
    redirect: indexmr1kouHjdRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/billings/[billing_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91billing_id_933bOYP3pdUoMeta?.name ?? undefined,
    meta: _91billing_id_933bOYP3pdUoMeta || {},
    alias: _91billing_id_933bOYP3pdUoMeta?.alias || [],
    redirect: _91billing_id_933bOYP3pdUoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/billings/[billing_id].vue").then(m => m.default || m)
  },
  {
    name: indexPFpfRUlkN6Meta?.name ?? "admin-billings",
    path: indexPFpfRUlkN6Meta?.path ?? "",
    meta: indexPFpfRUlkN6Meta || {},
    alias: indexPFpfRUlkN6Meta?.alias || [],
    redirect: indexPFpfRUlkN6Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/billings/index.vue").then(m => m.default || m)
  },
  {
    name: new1lyEIMF6ZgMeta?.name ?? "admin-billings-new",
    path: new1lyEIMF6ZgMeta?.path ?? "new",
    meta: new1lyEIMF6ZgMeta || {},
    alias: new1lyEIMF6ZgMeta?.alias || [],
    redirect: new1lyEIMF6ZgMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/billings/new.vue").then(m => m.default || m)
  }
],
    name: billingsZIEvDSzlxwMeta?.name ?? undefined,
    meta: billingsZIEvDSzlxwMeta || {},
    alias: billingsZIEvDSzlxwMeta?.alias || [],
    redirect: billingsZIEvDSzlxwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/billings.vue").then(m => m.default || m)
  },
  {
    path: caller_idsKepo0yoReQMeta?.path ?? "caller_ids",
    children: [
  {
    path: _91caller_id_id_93YHMdvKIT91Meta?.path ?? ":caller_id_id()",
    children: [
  {
    name: edit5MsEMHfvbjMeta?.name ?? "admin-caller_ids-caller_id_id-edit",
    path: edit5MsEMHfvbjMeta?.path ?? "edit",
    meta: edit5MsEMHfvbjMeta || {},
    alias: edit5MsEMHfvbjMeta?.alias || [],
    redirect: edit5MsEMHfvbjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/caller_ids/[caller_id_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexpAJ0jJKR8YMeta?.name ?? "admin-caller_ids-caller_id_id",
    path: indexpAJ0jJKR8YMeta?.path ?? "",
    meta: indexpAJ0jJKR8YMeta || {},
    alias: indexpAJ0jJKR8YMeta?.alias || [],
    redirect: indexpAJ0jJKR8YMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/caller_ids/[caller_id_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91caller_id_id_93YHMdvKIT91Meta?.name ?? undefined,
    meta: _91caller_id_id_93YHMdvKIT91Meta || {},
    alias: _91caller_id_id_93YHMdvKIT91Meta?.alias || [],
    redirect: _91caller_id_id_93YHMdvKIT91Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/caller_ids/[caller_id_id].vue").then(m => m.default || m)
  },
  {
    name: indexAMudmIpW0OMeta?.name ?? "admin-caller_ids",
    path: indexAMudmIpW0OMeta?.path ?? "",
    meta: indexAMudmIpW0OMeta || {},
    alias: indexAMudmIpW0OMeta?.alias || [],
    redirect: indexAMudmIpW0OMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/caller_ids/index.vue").then(m => m.default || m)
  },
  {
    name: newUXo5oDZE1CMeta?.name ?? "admin-caller_ids-new",
    path: newUXo5oDZE1CMeta?.path ?? "new",
    meta: newUXo5oDZE1CMeta || {},
    alias: newUXo5oDZE1CMeta?.alias || [],
    redirect: newUXo5oDZE1CMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/caller_ids/new.vue").then(m => m.default || m)
  }
],
    name: caller_idsKepo0yoReQMeta?.name ?? undefined,
    meta: caller_idsKepo0yoReQMeta || {},
    alias: caller_idsKepo0yoReQMeta?.alias || [],
    redirect: caller_idsKepo0yoReQMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/caller_ids.vue").then(m => m.default || m)
  },
  {
    path: _91campaign_setting_id_93CUtjSh1bGBMeta?.path ?? "campaign_settings/:campaign_setting_id()",
    children: [
  {
    name: editxfW8G4J5p1Meta?.name ?? "admin-campaign_settings-campaign_setting_id-edit",
    path: editxfW8G4J5p1Meta?.path ?? "edit",
    meta: editxfW8G4J5p1Meta || {},
    alias: editxfW8G4J5p1Meta?.alias || [],
    redirect: editxfW8G4J5p1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaign_settings/[campaign_setting_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexrCQAxNqNVrMeta?.name ?? "admin-campaign_settings-campaign_setting_id",
    path: indexrCQAxNqNVrMeta?.path ?? "",
    meta: indexrCQAxNqNVrMeta || {},
    alias: indexrCQAxNqNVrMeta?.alias || [],
    redirect: indexrCQAxNqNVrMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaign_settings/[campaign_setting_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91campaign_setting_id_93CUtjSh1bGBMeta?.name ?? undefined,
    meta: _91campaign_setting_id_93CUtjSh1bGBMeta || {},
    alias: _91campaign_setting_id_93CUtjSh1bGBMeta?.alias || [],
    redirect: _91campaign_setting_id_93CUtjSh1bGBMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaign_settings/[campaign_setting_id].vue").then(m => m.default || m)
  },
  {
    path: campaignsJirBcyOB9gMeta?.path ?? "campaigns",
    children: [
  {
    path: _91campaign_id_93vEXGD91MjnMeta?.path ?? ":campaign_id()",
    children: [
  {
    name: editgWyzyxtihMMeta?.name ?? "admin-campaigns-campaign_id-edit",
    path: editgWyzyxtihMMeta?.path ?? "edit",
    meta: editgWyzyxtihMMeta || {},
    alias: editgWyzyxtihMMeta?.alias || [],
    redirect: editgWyzyxtihMMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: index7VVY36UTlMMeta?.name ?? "admin-campaigns-campaign_id",
    path: index7VVY36UTlMMeta?.path ?? "",
    meta: index7VVY36UTlMMeta || {},
    alias: index7VVY36UTlMMeta?.alias || [],
    redirect: index7VVY36UTlMMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/index.vue").then(m => m.default || m)
  },
  {
    path: outbound_call_transactionsSyihUWet2XMeta?.path ?? "outbound_call_transactions",
    children: [
  {
    path: _91outbound_call_transaction_id_93X3D0S7Yr4zMeta?.path ?? ":outbound_call_transaction_id()",
    children: [
  {
    name: editz2ZTxVFu6oMeta?.name ?? "admin-campaigns-campaign_id-outbound_call_transactions-outbound_call_transaction_id-edit",
    path: editz2ZTxVFu6oMeta?.path ?? "edit",
    meta: editz2ZTxVFu6oMeta || {},
    alias: editz2ZTxVFu6oMeta?.alias || [],
    redirect: editz2ZTxVFu6oMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/[outbound_call_transaction_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexHBd2MpxbfvMeta?.name ?? "admin-campaigns-campaign_id-outbound_call_transactions-outbound_call_transaction_id",
    path: indexHBd2MpxbfvMeta?.path ?? "",
    meta: indexHBd2MpxbfvMeta || {},
    alias: indexHBd2MpxbfvMeta?.alias || [],
    redirect: indexHBd2MpxbfvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/[outbound_call_transaction_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91outbound_call_transaction_id_93X3D0S7Yr4zMeta?.name ?? undefined,
    meta: _91outbound_call_transaction_id_93X3D0S7Yr4zMeta || {},
    alias: _91outbound_call_transaction_id_93X3D0S7Yr4zMeta?.alias || [],
    redirect: _91outbound_call_transaction_id_93X3D0S7Yr4zMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/[outbound_call_transaction_id].vue").then(m => m.default || m)
  },
  {
    name: indexTf7v6IkEhtMeta?.name ?? "admin-campaigns-campaign_id-outbound_call_transactions",
    path: indexTf7v6IkEhtMeta?.path ?? "",
    meta: indexTf7v6IkEhtMeta || {},
    alias: indexTf7v6IkEhtMeta?.alias || [],
    redirect: indexTf7v6IkEhtMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/index.vue").then(m => m.default || m)
  },
  {
    name: newYdBnam8fz3Meta?.name ?? "admin-campaigns-campaign_id-outbound_call_transactions-new",
    path: newYdBnam8fz3Meta?.path ?? "new",
    meta: newYdBnam8fz3Meta || {},
    alias: newYdBnam8fz3Meta?.alias || [],
    redirect: newYdBnam8fz3Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions/new.vue").then(m => m.default || m)
  }
],
    name: outbound_call_transactionsSyihUWet2XMeta?.name ?? undefined,
    meta: outbound_call_transactionsSyihUWet2XMeta || {},
    alias: outbound_call_transactionsSyihUWet2XMeta?.alias || [],
    redirect: outbound_call_transactionsSyihUWet2XMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id]/outbound_call_transactions.vue").then(m => m.default || m)
  }
],
    name: _91campaign_id_93vEXGD91MjnMeta?.name ?? undefined,
    meta: _91campaign_id_93vEXGD91MjnMeta || {},
    alias: _91campaign_id_93vEXGD91MjnMeta?.alias || [],
    redirect: _91campaign_id_93vEXGD91MjnMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/[campaign_id].vue").then(m => m.default || m)
  },
  {
    name: indexT5Jk5sh9ofMeta?.name ?? "admin-campaigns",
    path: indexT5Jk5sh9ofMeta?.path ?? "",
    meta: indexT5Jk5sh9ofMeta || {},
    alias: indexT5Jk5sh9ofMeta?.alias || [],
    redirect: indexT5Jk5sh9ofMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: newNeYdB3zRjuMeta?.name ?? "admin-campaigns-new",
    path: newNeYdB3zRjuMeta?.path ?? "new",
    meta: newNeYdB3zRjuMeta || {},
    alias: newNeYdB3zRjuMeta?.alias || [],
    redirect: newNeYdB3zRjuMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns/new.vue").then(m => m.default || m)
  }
],
    name: campaignsJirBcyOB9gMeta?.name ?? undefined,
    meta: campaignsJirBcyOB9gMeta || {},
    alias: campaignsJirBcyOB9gMeta?.alias || [],
    redirect: campaignsJirBcyOB9gMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/campaigns.vue").then(m => m.default || m)
  },
  {
    path: custom_emailsVdOfn07PEOMeta?.path ?? "custom_emails",
    children: [
  {
    path: _91custom_email_id_933aGf6HmpmqMeta?.path ?? ":custom_email_id()",
    children: [
  {
    name: indexn9eZFKEX7AMeta?.name ?? "admin-custom_emails-custom_email_id",
    path: indexn9eZFKEX7AMeta?.path ?? "",
    meta: indexn9eZFKEX7AMeta || {},
    alias: indexn9eZFKEX7AMeta?.alias || [],
    redirect: indexn9eZFKEX7AMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/custom_emails/[custom_email_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91custom_email_id_933aGf6HmpmqMeta?.name ?? undefined,
    meta: _91custom_email_id_933aGf6HmpmqMeta || {},
    alias: _91custom_email_id_933aGf6HmpmqMeta?.alias || [],
    redirect: _91custom_email_id_933aGf6HmpmqMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/custom_emails/[custom_email_id].vue").then(m => m.default || m)
  },
  {
    name: indexluW1I0qVWjMeta?.name ?? "admin-custom_emails",
    path: indexluW1I0qVWjMeta?.path ?? "",
    meta: indexluW1I0qVWjMeta || {},
    alias: indexluW1I0qVWjMeta?.alias || [],
    redirect: indexluW1I0qVWjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/custom_emails/index.vue").then(m => m.default || m)
  },
  {
    name: newJu4cZXzymoMeta?.name ?? "admin-custom_emails-new",
    path: newJu4cZXzymoMeta?.path ?? "new",
    meta: newJu4cZXzymoMeta || {},
    alias: newJu4cZXzymoMeta?.alias || [],
    redirect: newJu4cZXzymoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/custom_emails/new.vue").then(m => m.default || m)
  }
],
    name: custom_emailsVdOfn07PEOMeta?.name ?? undefined,
    meta: custom_emailsVdOfn07PEOMeta || {},
    alias: custom_emailsVdOfn07PEOMeta?.alias || [],
    redirect: custom_emailsVdOfn07PEOMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/custom_emails.vue").then(m => m.default || m)
  },
  {
    path: dashboardnNq96eiiG4Meta?.path ?? "dashboard",
    children: [
  {
    name: indexCcXG9xY9KDMeta?.name ?? "admin-dashboard",
    path: indexCcXG9xY9KDMeta?.path ?? "",
    meta: indexCcXG9xY9KDMeta || {},
    alias: indexCcXG9xY9KDMeta?.alias || [],
    redirect: indexCcXG9xY9KDMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/dashboard/index.vue").then(m => m.default || m)
  }
],
    name: dashboardnNq96eiiG4Meta?.name ?? undefined,
    meta: dashboardnNq96eiiG4Meta || {},
    alias: dashboardnNq96eiiG4Meta?.alias || [],
    redirect: dashboardnNq96eiiG4Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/dashboard.vue").then(m => m.default || m)
  },
  {
    path: inquiriesHYEHr2t4HKMeta?.path ?? "inquiries",
    children: [
  {
    path: _91inquiry_id_93TiOqU4yWW2Meta?.path ?? ":inquiry_id()",
    children: [
  {
    name: index0OPBczMLtAMeta?.name ?? "admin-inquiries-inquiry_id",
    path: index0OPBczMLtAMeta?.path ?? "",
    meta: index0OPBczMLtAMeta || {},
    alias: index0OPBczMLtAMeta?.alias || [],
    redirect: index0OPBczMLtAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/inquiries/[inquiry_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91inquiry_id_93TiOqU4yWW2Meta?.name ?? undefined,
    meta: _91inquiry_id_93TiOqU4yWW2Meta || {},
    alias: _91inquiry_id_93TiOqU4yWW2Meta?.alias || [],
    redirect: _91inquiry_id_93TiOqU4yWW2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/inquiries/[inquiry_id].vue").then(m => m.default || m)
  },
  {
    name: indexP7oReG5H3pMeta?.name ?? "admin-inquiries",
    path: indexP7oReG5H3pMeta?.path ?? "",
    meta: indexP7oReG5H3pMeta || {},
    alias: indexP7oReG5H3pMeta?.alias || [],
    redirect: indexP7oReG5H3pMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/inquiries/index.vue").then(m => m.default || m)
  },
  {
    name: newH7K0c6kkISMeta?.name ?? "admin-inquiries-new",
    path: newH7K0c6kkISMeta?.path ?? "new",
    meta: newH7K0c6kkISMeta || {},
    alias: newH7K0c6kkISMeta?.alias || [],
    redirect: newH7K0c6kkISMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/inquiries/new.vue").then(m => m.default || m)
  }
],
    name: inquiriesHYEHr2t4HKMeta?.name ?? undefined,
    meta: inquiriesHYEHr2t4HKMeta || {},
    alias: inquiriesHYEHr2t4HKMeta?.alias || [],
    redirect: inquiriesHYEHr2t4HKMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/inquiries.vue").then(m => m.default || m)
  },
  {
    path: loginGsJanrWgUKMeta?.path ?? "login",
    children: [
  {
    name: indexwb5Jyab79MMeta?.name ?? "admin-login",
    path: indexwb5Jyab79MMeta?.path ?? "",
    meta: indexwb5Jyab79MMeta || {},
    alias: indexwb5Jyab79MMeta?.alias || [],
    redirect: indexwb5Jyab79MMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/login/index.vue").then(m => m.default || m)
  }
],
    name: loginGsJanrWgUKMeta?.name ?? undefined,
    meta: loginGsJanrWgUKMeta || {},
    alias: loginGsJanrWgUKMeta?.alias || [],
    redirect: loginGsJanrWgUKMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/login.vue").then(m => m.default || m)
  },
  {
    name: index6OLGGLnj9rMeta?.name ?? "admin-password-edit",
    path: index6OLGGLnj9rMeta?.path ?? "password/edit",
    meta: index6OLGGLnj9rMeta || {},
    alias: index6OLGGLnj9rMeta?.alias || [],
    redirect: index6OLGGLnj9rMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/password/edit/index.vue").then(m => m.default || m)
  },
  {
    name: index21hrkRnbR6Meta?.name ?? "admin-password-new",
    path: index21hrkRnbR6Meta?.path ?? "password/new",
    meta: index21hrkRnbR6Meta || {},
    alias: index21hrkRnbR6Meta?.alias || [],
    redirect: index21hrkRnbR6Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/password/new/index.vue").then(m => m.default || m)
  },
  {
    path: reportsuquZV5r9IlMeta?.path ?? "reports",
    children: [
  {
    name: indexfiI5YVGc2iMeta?.name ?? "admin-reports",
    path: indexfiI5YVGc2iMeta?.path ?? "",
    meta: indexfiI5YVGc2iMeta || {},
    alias: indexfiI5YVGc2iMeta?.alias || [],
    redirect: indexfiI5YVGc2iMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/reports/index.vue").then(m => m.default || m)
  }
],
    name: reportsuquZV5r9IlMeta?.name ?? undefined,
    meta: reportsuquZV5r9IlMeta || {},
    alias: reportsuquZV5r9IlMeta?.alias || [],
    redirect: reportsuquZV5r9IlMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/reports.vue").then(m => m.default || m)
  },
  {
    path: sms_maskingsmSDMtqMwLvMeta?.path ?? "sms_maskings",
    children: [
  {
    path: _91sms_masking_id_937Yq715HqMXMeta?.path ?? ":sms_masking_id()",
    children: [
  {
    name: edituooYjkbTEMMeta?.name ?? "admin-sms_maskings-sms_masking_id-edit",
    path: edituooYjkbTEMMeta?.path ?? "edit",
    meta: edituooYjkbTEMMeta || {},
    alias: edituooYjkbTEMMeta?.alias || [],
    redirect: edituooYjkbTEMMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/sms_maskings/[sms_masking_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexTbkTF6C4WBMeta?.name ?? "admin-sms_maskings-sms_masking_id",
    path: indexTbkTF6C4WBMeta?.path ?? "",
    meta: indexTbkTF6C4WBMeta || {},
    alias: indexTbkTF6C4WBMeta?.alias || [],
    redirect: indexTbkTF6C4WBMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/sms_maskings/[sms_masking_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91sms_masking_id_937Yq715HqMXMeta?.name ?? undefined,
    meta: _91sms_masking_id_937Yq715HqMXMeta || {},
    alias: _91sms_masking_id_937Yq715HqMXMeta?.alias || [],
    redirect: _91sms_masking_id_937Yq715HqMXMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/sms_maskings/[sms_masking_id].vue").then(m => m.default || m)
  },
  {
    name: indexn3qKoi5ahoMeta?.name ?? "admin-sms_maskings",
    path: indexn3qKoi5ahoMeta?.path ?? "",
    meta: indexn3qKoi5ahoMeta || {},
    alias: indexn3qKoi5ahoMeta?.alias || [],
    redirect: indexn3qKoi5ahoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/sms_maskings/index.vue").then(m => m.default || m)
  },
  {
    name: newEPx24wLIzcMeta?.name ?? "admin-sms_maskings-new",
    path: newEPx24wLIzcMeta?.path ?? "new",
    meta: newEPx24wLIzcMeta || {},
    alias: newEPx24wLIzcMeta?.alias || [],
    redirect: newEPx24wLIzcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/sms_maskings/new.vue").then(m => m.default || m)
  }
],
    name: sms_maskingsmSDMtqMwLvMeta?.name ?? undefined,
    meta: sms_maskingsmSDMtqMwLvMeta || {},
    alias: sms_maskingsmSDMtqMwLvMeta?.alias || [],
    redirect: sms_maskingsmSDMtqMwLvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/sms_maskings.vue").then(m => m.default || m)
  },
  {
    path: usersc9uL0sFKgMMeta?.path ?? "users",
    children: [
  {
    path: _91user_id_93OV13ot21yTMeta?.path ?? ":user_id()",
    children: [
  {
    name: editmgm7RBLg0pMeta?.name ?? "admin-users-user_id-edit",
    path: editmgm7RBLg0pMeta?.path ?? "edit",
    meta: editmgm7RBLg0pMeta || {},
    alias: editmgm7RBLg0pMeta?.alias || [],
    redirect: editmgm7RBLg0pMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/users/[user_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexqODNmed2QrMeta?.name ?? "admin-users-user_id",
    path: indexqODNmed2QrMeta?.path ?? "",
    meta: indexqODNmed2QrMeta || {},
    alias: indexqODNmed2QrMeta?.alias || [],
    redirect: indexqODNmed2QrMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/users/[user_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91user_id_93OV13ot21yTMeta?.name ?? undefined,
    meta: _91user_id_93OV13ot21yTMeta || {},
    alias: _91user_id_93OV13ot21yTMeta?.alias || [],
    redirect: _91user_id_93OV13ot21yTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/users/[user_id].vue").then(m => m.default || m)
  },
  {
    name: indexjqyLBfmpj5Meta?.name ?? "admin-users",
    path: indexjqyLBfmpj5Meta?.path ?? "",
    meta: indexjqyLBfmpj5Meta || {},
    alias: indexjqyLBfmpj5Meta?.alias || [],
    redirect: indexjqyLBfmpj5Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/users/index.vue").then(m => m.default || m)
  },
  {
    name: newQGMESc0rO8Meta?.name ?? "admin-users-new",
    path: newQGMESc0rO8Meta?.path ?? "new",
    meta: newQGMESc0rO8Meta || {},
    alias: newQGMESc0rO8Meta?.alias || [],
    redirect: newQGMESc0rO8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/users/new.vue").then(m => m.default || m)
  }
],
    name: usersc9uL0sFKgMMeta?.name ?? undefined,
    meta: usersc9uL0sFKgMMeta || {},
    alias: usersc9uL0sFKgMMeta?.alias || [],
    redirect: usersc9uL0sFKgMMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    path: _91wallet_id_93LV7eimG0xEMeta?.path ?? "wallets/:wallet_id()",
    children: [
  {
    name: editCJbvCGj0fEMeta?.name ?? "admin-wallets-wallet_id-edit",
    path: editCJbvCGj0fEMeta?.path ?? "edit",
    meta: editCJbvCGj0fEMeta || {},
    alias: editCJbvCGj0fEMeta?.alias || [],
    redirect: editCJbvCGj0fEMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/wallets/[wallet_id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexcc7ASpMDfOMeta?.name ?? "admin-wallets-wallet_id",
    path: indexcc7ASpMDfOMeta?.path ?? "",
    meta: indexcc7ASpMDfOMeta || {},
    alias: indexcc7ASpMDfOMeta?.alias || [],
    redirect: indexcc7ASpMDfOMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/wallets/[wallet_id]/index.vue").then(m => m.default || m)
  }
],
    name: _91wallet_id_93LV7eimG0xEMeta?.name ?? undefined,
    meta: _91wallet_id_93LV7eimG0xEMeta || {},
    alias: _91wallet_id_93LV7eimG0xEMeta?.alias || [],
    redirect: _91wallet_id_93LV7eimG0xEMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin/wallets/[wallet_id].vue").then(m => m.default || m)
  }
],
    meta: adminXF7wRbHDD1Meta || {},
    alias: adminXF7wRbHDD1Meta?.alias || [],
    redirect: adminXF7wRbHDD1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/admin.vue").then(m => m.default || m)
  },
  {
    name: indexM7vvfplj2QMeta?.name ?? "audit_logs",
    path: indexM7vvfplj2QMeta?.path ?? "/audit_logs",
    meta: indexM7vvfplj2QMeta || {},
    alias: indexM7vvfplj2QMeta?.alias || [],
    redirect: indexM7vvfplj2QMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/audit_logs/index.vue").then(m => m.default || m)
  },
  {
    name: indexQdGITE8dEmMeta?.name ?? "billings",
    path: indexQdGITE8dEmMeta?.path ?? "/billings",
    meta: indexQdGITE8dEmMeta || {},
    alias: indexQdGITE8dEmMeta?.alias || [],
    redirect: indexQdGITE8dEmMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/billings/index.vue").then(m => m.default || m)
  },
  {
    name: indexwt0h2JMpSEMeta?.name ?? "call_out-reports",
    path: indexwt0h2JMpSEMeta?.path ?? "/call_out/reports",
    meta: indexwt0h2JMpSEMeta || {},
    alias: indexwt0h2JMpSEMeta?.alias || [],
    redirect: indexwt0h2JMpSEMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/call_out/reports/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93YTOoynxhIOMeta?.name ?? "call_recordings-id",
    path: _91id_93YTOoynxhIOMeta?.path ?? "/call_recordings/:id()",
    meta: _91id_93YTOoynxhIOMeta || {},
    alias: _91id_93YTOoynxhIOMeta?.alias || [],
    redirect: _91id_93YTOoynxhIOMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/call_recordings/[id].vue").then(m => m.default || m)
  },
  {
    name: index8emJTl2pzjMeta?.name ?? "campaigns-id",
    path: index8emJTl2pzjMeta?.path ?? "/campaigns/:id()",
    meta: index8emJTl2pzjMeta || {},
    alias: index8emJTl2pzjMeta?.alias || [],
    redirect: index8emJTl2pzjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/campaigns/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexWP5PnavcUTMeta?.name ?? "campaigns",
    path: indexWP5PnavcUTMeta?.path ?? "/campaigns",
    meta: indexWP5PnavcUTMeta || {},
    alias: indexWP5PnavcUTMeta?.alias || [],
    redirect: indexWP5PnavcUTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: index1WtvJktryRMeta?.name ?? "dashboard",
    path: index1WtvJktryRMeta?.path ?? "/dashboard",
    meta: index1WtvJktryRMeta || {},
    alias: index1WtvJktryRMeta?.alias || [],
    redirect: index1WtvJktryRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: validate_email_changeslRNPN3NfFNMeta?.name ?? "data_verifications-id-validate_email_changes",
    path: validate_email_changeslRNPN3NfFNMeta?.path ?? "/data_verifications/:id()/validate_email_changes",
    meta: validate_email_changeslRNPN3NfFNMeta || {},
    alias: validate_email_changeslRNPN3NfFNMeta?.alias || [],
    redirect: validate_email_changeslRNPN3NfFNMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/data_verifications/[id]/validate_email_changes.vue").then(m => m.default || m)
  },
  {
    name: indexMyCnNmDEmOMeta?.name ?? "help",
    path: indexMyCnNmDEmOMeta?.path ?? "/help",
    meta: indexMyCnNmDEmOMeta || {},
    alias: indexMyCnNmDEmOMeta?.alias || [],
    redirect: indexMyCnNmDEmOMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: indexZw2qRISpDJMeta?.name ?? "index",
    path: indexZw2qRISpDJMeta?.path ?? "/",
    meta: indexZw2qRISpDJMeta || {},
    alias: indexZw2qRISpDJMeta?.alias || [],
    redirect: indexZw2qRISpDJMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indextEc0viaT5tMeta?.name ?? "inquiry",
    path: indextEc0viaT5tMeta?.path ?? "/inquiry",
    meta: indextEc0viaT5tMeta || {},
    alias: indextEc0viaT5tMeta?.alias || [],
    redirect: indextEc0viaT5tMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/inquiry/index.vue").then(m => m.default || m)
  },
  {
    name: editorvOK56c47KtMeta?.name ?? "ivr_trees-id-editor",
    path: editorvOK56c47KtMeta?.path ?? "/ivr_trees/:id()/editor",
    meta: editorvOK56c47KtMeta || {},
    alias: editorvOK56c47KtMeta?.alias || [],
    redirect: editorvOK56c47KtMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/ivr_trees/[id]/editor.vue").then(m => m.default || m)
  },
  {
    name: index4ub0A5D8HPMeta?.name ?? "ivr_trees",
    path: index4ub0A5D8HPMeta?.path ?? "/ivr_trees",
    meta: index4ub0A5D8HPMeta || {},
    alias: index4ub0A5D8HPMeta?.alias || [],
    redirect: index4ub0A5D8HPMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/ivr_trees/index.vue").then(m => m.default || m)
  },
  {
    name: verify_emaill37p8wpj6TMeta?.name ?? "profiles-user_id-verify_email",
    path: verify_emaill37p8wpj6TMeta?.path ?? "/profiles/:user_id()/verify_email",
    meta: verify_emaill37p8wpj6TMeta || {},
    alias: verify_emaill37p8wpj6TMeta?.alias || [],
    redirect: verify_emaill37p8wpj6TMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/profiles/[user_id]/verify_email.vue").then(m => m.default || m)
  },
  {
    name: welcome_dashboard0wIZb4eGlvMeta?.name ?? "profiles-user_id-welcome_dashboard",
    path: welcome_dashboard0wIZb4eGlvMeta?.path ?? "/profiles/:user_id()/welcome_dashboard",
    meta: welcome_dashboard0wIZb4eGlvMeta || {},
    alias: welcome_dashboard0wIZb4eGlvMeta?.alias || [],
    redirect: welcome_dashboard0wIZb4eGlvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/profiles/[user_id]/welcome_dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexbzPkVNONxOMeta?.name ?? "profiles",
    path: indexbzPkVNONxOMeta?.path ?? "/profiles",
    meta: indexbzPkVNONxOMeta || {},
    alias: indexbzPkVNONxOMeta?.alias || [],
    redirect: indexbzPkVNONxOMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/profiles/index.vue").then(m => m.default || m)
  },
  {
    name: indexnCEmVxvBUmMeta?.name ?? "sub_users-users",
    path: indexnCEmVxvBUmMeta?.path ?? "/sub_users/users",
    meta: indexnCEmVxvBUmMeta || {},
    alias: indexnCEmVxvBUmMeta?.alias || [],
    redirect: indexnCEmVxvBUmMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/sub_users/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexNMovEzJ5SyMeta?.name ?? "terms_and_conditions",
    path: indexNMovEzJ5SyMeta?.path ?? "/terms_and_conditions",
    meta: indexNMovEzJ5SyMeta || {},
    alias: indexNMovEzJ5SyMeta?.alias || [],
    redirect: indexNMovEzJ5SyMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/terms_and_conditions/index.vue").then(m => m.default || m)
  },
  {
    name: indexF3tP7fqxekMeta?.name ?? "users-password-edit",
    path: indexF3tP7fqxekMeta?.path ?? "/users/password/edit",
    meta: indexF3tP7fqxekMeta || {},
    alias: indexF3tP7fqxekMeta?.alias || [],
    redirect: indexF3tP7fqxekMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/users/password/edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexQzdulnbVcTMeta?.name ?? "users-password-new",
    path: indexQzdulnbVcTMeta?.path ?? "/users/password/new",
    meta: indexQzdulnbVcTMeta || {},
    alias: indexQzdulnbVcTMeta?.alias || [],
    redirect: indexQzdulnbVcTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/users/password/new/index.vue").then(m => m.default || m)
  },
  {
    name: index6EDCMFM6ZWMeta?.name ?? "users-sign_in",
    path: index6EDCMFM6ZWMeta?.path ?? "/users/sign_in",
    meta: index6EDCMFM6ZWMeta || {},
    alias: index6EDCMFM6ZWMeta?.alias || [],
    redirect: index6EDCMFM6ZWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src1332377934/src/pages/users/sign_in/index.vue").then(m => m.default || m)
  }
]